import React from 'react';
import { OverlayNavigation, TopBar, } from '@flow/components/navigation';
import { connect } from 'react-redux';

interface Props {
  appLanguage: IAppLanguage;
  lang_versions: LangVersions;
}

class NavigationContainer extends React.Component<Props, any> {

  render() {

    const {
      appLanguage,
      lang_versions,
    } = this.props;

    return (
      <div>
        <TopBar appLanguage={appLanguage} lang_versions={lang_versions}/>
        <OverlayNavigation appLanguage={appLanguage}/>
      </div>
    )
  }
}

const mapStateToProps = ({ navigationReducer }: any) => {
  const {
    appLanguage,
    lang_versions,
  } = navigationReducer;

  try {
    if (typeof window !== undefined) {
      localStorage.setItem('locale', appLanguage.code);
    }
  } catch (e) {}

  return {
    appLanguage,
    lang_versions
  }
};

export const Navigation = connect(
  mapStateToProps
)(NavigationContainer);

export default Navigation;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/navigation/Navigation.tsx